import React, { Component } from "react";
import styled from "styled-components";
import { Whisper, Popover, Button } from "rsuite";
import { handleSendSms } from "../scripts/helper";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { SelectedDeviceSelector } from "../redux/selector";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  background-image: url(/assets/pic_home_bg.png);
  background-size: contain;
  background-position: center;
  align-items: center;
  background-repeat: no-repeat;
  min-height: 45vw;
`;
const Right = styled.img`
  width: 16vw;
  max-width: 75px;
  position: relative;
  top: 28px;
  transition: 100ms;
  &:active {
    transform: scale(0.85);
  }
`;
const Left = styled.img`
  width: 16vw;
  max-width: 75px;
  position: relative;
  top: 28px;
  transition: 100ms;
  &:active {
    transform: scale(0.85);
  }
`;
const PopoverContainer = styled.div`
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

class MiddleHomeComponent extends Component {
  handleClickItem = (smsBody) => {
    const { selectedDevice } = this.props;
    console.log("IM FIRE");
    console.log(smsBody);
    console.log(selectedDevice);
    handleSendSms(smsBody, selectedDevice);
  };
  render() {
    return (
      <Container>
        <Whisper
          placement="right"
          speaker={
            <Popover as={PopoverContainer}>
              <Button block onTouchStart={() => this.handleClickItem("باز۱")}>
                باز ۱
              </Button>
              <Button block onTouchStart={() => this.handleClickItem("باز۲")}>
                باز ۲
              </Button>
            </Popover>
          }
        >
          <Right
            src="/assets/ic_home_un_lock.png"
            alt="unlock"
            onClick={this.handleClickUnlock}
          />
        </Whisper>
        <Whisper
          placement="left"
          speaker={
            <Popover as={PopoverContainer}>
              <Button block onTouchStart={() => this.handleClickItem("قفل۱")}>
                قفل ۱
              </Button>
              <Button block onTouchStart={() => this.handleClickItem("قفل۲")}>
                قفل ۲
              </Button>
            </Popover>
          }
        >
          <Left
            src="/assets/ic_home_lock.png"
            alt="lock"
            onClick={this.handleClickLock}
          />
        </Whisper>
      </Container>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  selectedDevice: SelectedDeviceSelector,
});

export default connect(mapStateToProps)(MiddleHomeComponent);
